import * as React from 'react';
import { useSelector } from 'store/hooks';
import Forbidden from 'components/Errors/Forbidden';

type Props = {
    children: React.ReactNode;
};

/**
 * Component to wrap budget overview routes to check if client has DAF access or is support user
 * else display forbidden page
 */
const BudgetOverviewWithAccessCheck: React.FC<Props> = ({ children }) => {
    const { hasAccessDaf, isSupportUser } = useSelector((state) => ({
        hasAccessDaf: state.vision.hasAccessDaf,
        isSupportUser: state.vision.isSupportUser,
    }));
    if (!hasAccessDaf && !isSupportUser) {
        return <Forbidden />;
    }
    return children;
};

export default BudgetOverviewWithAccessCheck;
